import AccountList from 'common/pages/account/AccountList.tsx'

export const AccountListAgency = (props: any) => <AccountList {...props} mode={props.mode}/>